'use client'
import React from 'react'

import LocationIntro from '../../sections/locationIntro'
import CtaSection from '../../sections/ctaSection'
import LocationInfo from '../../sections/locationInfo'
import Providers from '../../sections/providers'
import NewsShortSection from '../../sections/newsShortSection'
import FaqSection from '../../sections/faq'

import PageWrapperMainSite from '../../pageWrapper'
import StaticMapSection from '../../sections/mapsStatic'

import BreadCrumbs from '../../sections/breadcrumbs'
import PlayingFieldsSection from '../../sections/playingFields'
import EventCalendarHome from '../../sections/eventsCalendarHome'

const LocationPage = ({
  title,
  intro_text,
  info_lists,
  body,
  get_snel_naar,
  facilities,
  address,
  clubs,
  sublocations,
  news,
  footer,
  header,
  breadcrumbs,
  cta,
  header_image,
  playing_fields,
  last_examination,
  contact,
  events,
  faq,
}) => {
  const intro_link = get_snel_naar && get_snel_naar[0] && get_snel_naar[0].value

  const {
    link: cta_cta,
    image: cta_image,
    text: cta_text,
  } = cta && cta.length > 0 ? cta[0].value : {}

  const cta_link = cta_cta
    ? {
        text: cta_cta?.text,
        href: cta_cta?.href ? cta_cta?.href : cta_cta?.external_url,
      }
    : {}

  const useAddress = address?.length && address[0]

  const coordinates =
    useAddress?.latitude && useAddress.longitude
      ? [`${useAddress.latitude},${useAddress.longitude}`]
      : null

  return (
    <>
      <BreadCrumbs breadcrumbs={breadcrumbs} spacing={60} />
      <LocationIntro
        intro={intro_text}
        link={intro_link}
        lists={info_lists}
        body={body}
        firstH1={false}
      />
      {cta?.length && (
        <CtaSection cta={cta_link} text={cta_text} image={cta_image} />
      )}
      {sublocations?.length || facilities?.length ? (
        <LocationInfo
          title={title}
          sublocations={sublocations}
          facilities={facilities}
        />
      ) : null}

      {playing_fields?.length ? (
        <PlayingFieldsSection
          fields={playing_fields}
          last_examination={last_examination}
          locationCoordinates={
            coordinates
              ? {
                  lat: parseFloat(useAddress?.latitude),
                  lng: parseFloat(useAddress.longitude),
                }
              : null
          }
        />
      ) : null}

      {clubs?.clubs?.length ? (
        <Providers
          title={clubs.title}
          text={clubs.text}
          perPage={3}
          providers={clubs?.clubs || []}
          totalCount={clubs?.clubs?.length || 0}
          background="transparent"
        />
      ) : null}
      {news?.news?.length ? (
        <NewsShortSection title={news.title} button={false} news={news?.news} />
      ) : null}

      {events?.length ? (
        <EventCalendarHome
          title="Aankomende evenementen"
          events={events}
          hideButton={true}
        />
      ) : null}

      {faq?.length ? <FaqSection title="FAQ" questions={faq} /> : null}

      {coordinates ? (
        <StaticMapSection
          locations={coordinates}
          width={600}
          height={600}
          markersOnly
        />
      ) : null}
    </>
  )
}

export default LocationPage
